import moment from 'moment-timezone';
import globalConstants from '../../shared/appConfig/globalConstants';
import { store } from '../redux/store';
import { dateUtils } from '../utilities/dateUtils';
import { getStartTimeWithLeadTime } from './getStartTimeWithLeadTime';
import { getWorkingHours } from './getWorkingHours';
import { EstimatedDeliveryWindow } from '@bungii/scheduling-utility';

export const DeliveryTimeRange = (selectedTime = '', estTime = '') => {
    const { serviceLevel, pickupTime } = store.getState().getEstimate;
    const time = (selectedTime) ? selectedTime : pickupTime;
    const currentPlusTotal = moment(time, globalConstants.HourFormat3).add(estTime ? estTime : serviceLevel['TotalPickupTime'], 'minutes');
    return getEstimatedDeliveryWindow(currentPlusTotal);
};

/**
 * getEstimatedDeliveryWindow()
 * This function is used to find the estimated delivery window for the selected date
 */
export const getEstimatedDeliveryWindow = (estimatedDeliveryMoment, scheduledTimestamp) => {
    const { timeZone, serviceLevel, pickupTime, vehicleCategories } = store.getState().getEstimate;
    const { DayTimeFormat, RoundToNearestMinuteValue, HourFormat, HourFormat3 } = globalConstants;

    const matchingCategory = serviceLevel
        ? vehicleCategories?.find(v => v.category === serviceLevel?.VehicleCategory)
        : vehicleCategories?.[0];
    const deliveryWindowConfig = matchingCategory?.config?.deliveryWindow || {};
    const pickupMoment = moment.tz(pickupTime, HourFormat3, true, timeZone);

    // Destructure expected config values
    const {
        startTimeOffsetMinutes = 0,
        endTimeOffsetMinutes = 0,
        pickupTimeBufferMinutes = 0,
    } = deliveryWindowConfig;

    // Create EstimatedDeliveryWindow instance  
    const schedulingUtility = new EstimatedDeliveryWindow(
        startTimeOffsetMinutes,
        endTimeOffsetMinutes,
        pickupTimeBufferMinutes,
    );

    // Determine the scheduled pickup time 
    const scheduledMoment = scheduledTimestamp
        ? moment.utc(scheduledTimestamp, DayTimeFormat)
        : pickupMoment.clone();

    // Round estimated delivery moment to nearest 5 minutes
    const minutes = estimatedDeliveryMoment.minutes();
    const roundedMinutes = Math.ceil(minutes / RoundToNearestMinuteValue) * RoundToNearestMinuteValue;
    const roundedEstimatedMoment = estimatedDeliveryMoment.clone().minutes(roundedMinutes).seconds(0).milliseconds(0);

    // Convert to ISO 8601 strings for the utility class
    const pickupIso = scheduledMoment.toISOString();
    const estimatedIso = roundedEstimatedMoment.toISOString();

    // Calculate delivery window
    let fromTime, toTime;

    try {
        const result = schedulingUtility.calculate(pickupIso, estimatedIso);

        if (result?.fromTime && result?.toTime) {
            fromTime = dateUtils.convertTimezone(result.fromTime, timeZone, HourFormat);
            toTime = dateUtils.convertTimezone(result.toTime, timeZone, HourFormat);
        } else {
            throw new Error('Invalid delivery window result');
        }
    } catch (error) {
        console.error('Delivery window calculation failed:', error);
        fromTime = toTime = undefined;
    }

    return `${fromTime} - ${toTime}`;
};

/**
 * getSlotsForTheDay()
 * This function is used to find the available time slots for the selected date
 */
export const getSlotsForTheDay = (totalSlots, todaysDate) => {
    const availableTimeSlots = [];
    const { WorkingHoursStart, WorkingHoursEnd } = getWorkingHours();
    const min = WorkingHoursStart;
    const max = WorkingHoursEnd;
    const datePassed = new Date(todaysDate);
    const newDate = `${datePassed.getFullYear()}/${('0' + (datePassed.getMonth() + 1)).slice(-2)}/${('0' + datePassed.getDate()).slice(-2)}`
    const minTime = moment(min).utc().format(globalConstants.HourFormat2);
    const minSlotTime = dateUtils.getTimeStampSafari(`${newDate} ${minTime}`);

    const maxTime = moment(max).utc().format(globalConstants.HourFormat2);
    const maxSlotTime = dateUtils.getTimeStampSafari(`${newDate} ${maxTime}`);
    const currentTimeWithBuffer = getStartTimeWithLeadTime();
    totalSlots.map((item) => {
        // Get slot Time ( EPOCH time value )
        const slotDate = item['slot_date'].substr(0, item['slot_date'].indexOf('T')).replace(/-/g, "/");
        const slotTime = dateUtils.getTimeStampSafari(`${slotDate} ${item['time_slot_from']}`);
        // Display all time slots greater than ( current Time + Buffer Time ) where todaysDate is pickup date
        if (moment.utc(item['slot_date']).format(globalConstants.DateFormat2) === newDate && slotTime > currentTimeWithBuffer && slotTime >= minSlotTime && slotTime <= maxSlotTime) {
            availableTimeSlots.push(item);
        }
        return true;
    })
    return availableTimeSlots;
}
